import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";

import RouteQaCloud from "./App/Router/index";
import data from "../package.json";

// --- Cache bust by version ---
const APP_VERSION = data.version;
const stored = localStorage.getItem("APP_VERSION");
async function purgeOldCaches() {
    if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
    }
}
// Clear caches when version changed
if (stored && stored !== APP_VERSION) {
    purgeOldCaches().finally(() => {
        localStorage.setItem("APP_VERSION", APP_VERSION);
        // Soft reload to load đúng bundle mới (tránh trắng trang)
        window.location.reload();
    });
} else if (!stored) {
    localStorage.setItem("APP_VERSION", APP_VERSION);
}
// Optional: expose version
window.__APP_VERSION__ = APP_VERSION;

// --- Optional: remove legacy service workers (nếu từng dùng) ---
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
}

// --- Normalize basename (only path) ---
function extractPath(homepage) {
    if (!homepage) return "";
    try {
        const u = new URL(homepage, window.location.origin);
        return u.pathname.replace(/\/+$/, "");
    } catch {
        return homepage.replace(/\/+$/, "");
    }
}
const basename = extractPath(data.homepage) || "/cloud";

// --- Auto reload once if chunk missing after deploy (hash mismatch) ---
let chunkReloaded = false;
window.addEventListener("error", e => {
    if (/ChunkLoadError|Loading chunk/i.test(e?.message || "")) {
        if (!chunkReloaded) {
            chunkReloaded = true;
            purgeOldCaches().finally(() => window.location.reload());
        }
    }
}, true);

ReactDOM.render(
    <React.StrictMode>
        {/* <Router basename='/cloud'> */}
        <Router basename={data.homepage}>
            <RouteQaCloud />
        </Router>
        {/* <App /> */}
    </React.StrictMode>,
    document.getElementById("root")
);
